import { combineReducers } from 'redux-immutable';

import clientReducer from './client/reducer';
import overviewReducer from './overview/reducer';
import wizzardReducer from './connect-wizzard/reducer';
import monitorOverallStatsReducer from './overallStats/reducer';
import monitorShareableReportReducer from './shareableReport/reducer';
import entitiesBatchReducer from './entitiesBatch/reducer';
import benchmarkReducer from './benchmark/reducer';
import clientsTotalReducer from './clientsTotal/reducer';
import clientsRequiringAttentionReducer from './clientsRequiringAttention/reducer';
import productMatchesReducer from './productMatches/reducer';
import conversationsReducer from './conversations/reducer';
import tagsReducer from './tags/reducer';
import timelineReducer from './timeline/reducer';

export {
  closeMonitorBankDataLoadingErrorModal,
  closeMonitorBankDataLoadingModal,
  closeMonitorClientPage,
  closeInviteClientToBankingSolutionModal,
  openMonitorBankDataLoadingErrorModal,
  openMonitorBankDataLoadingModal,
  setCurrentMonitorClientId,
  setMonitorClientPageTab,
  openInviteClientToBankingSolutionModal,
  removeSnapshot,
  requestSnapshot,
  requestSnapshotAccounts,
  requestDeleteCreditLine,
  openHealthReport,
  closeHealthReport,
  requestSnapshotAccountsSuccess,
  requestUpdateSnapshotAccount,
  requestUpdateSnapshotAccounts,
  setMonitorClientBalanceSheetViewType,
  setMonitorClientBalanceSheetViewTypeSuccess,
  triggerSnapshotCreation,
} from './client/reducer';

export {
  requestAllClients,
  requestClient,
  requestClientUpdateNote,
  requestClientUpdateNoteSuccess,
  requestClientUpdateManager,
  setMonitorStatusFilters,
  setMonitorTagsFilters,
  setMonitorPropertiesFilters,
  removeMonitorFilters,
  setMonitorWizzardRedirectClientId,
  changeClientsLoadingState,
  setMonitorFilterByManager,
  setMonitorArchivedView,
} from './overview/reducer';

export {
  requestPostBenchmarkData,
  requestPostBenchmarkDataSuccess,
  requestPostBenchmarkDataFailure,
} from './benchmark/reducer';

export { monitorOverallStatsRequest } from './overallStats/reducer';

export { monitorProductMatchesRequest } from './productMatches/reducer';

export {
  addMonitorWizzardCreditFacility,
  addMonitorWizzardLedgerProviderFacility,
  closeMonitorWizzard,
  closeMonitorWizzardDataLoadingErrorModal,
  closeMonitorWizzardDataLoadingModal,
  openMonitorWizzard,
  openMonitorWizzardDataLoadingErrorModal,
  openMonitorWizzardDataLoadingModal,
  postCreditLinesFacilityMap,
  saveFacility,
  requestDeleteFacility,
  setEditFacilityWizzard,
  requestFacilitiesMap,
  removeMonitorWizzardCreditFacility,
  removeMonitorWizzardLedgerProviderFacility,
  requestBusinessFundingSearches,
  requestClientAccounts,
  requestActiveLenders,
  setMonitorWizzardAccountingSolution,
  setMonitorWizzardClient,
  setMonitorWizzardProviderFacilityValid,
  clearAddNewClientWizzardCompaniesList,
  requestCreateBusiness,
  requestCreateBusinessEntities,
  requestSearchCompany,
  sendCreditReport,
  downloadCreditReportPdf,
  triggerXeroUpload,
  saveIntegrationFilePayload,
  resetIntegrationFilePayload,
  addConnectionHistoryListItem,
  removeConnectionHistoryListItem,
  updateConnectionHistoryListItem,
} from './connect-wizzard/reducer';

export { updateSectionVisibility } from './shareableReport/reducer';

export {
  clientsRequiringAttentionRequest,
  clientsRequiringAttentionSuccess,
  clientsRequiringAttentionFailure,
} from './clientsRequiringAttention/reducer';

export {
  clientEncodedDataRequest,
  clientsTotalRequest,
  clientsTotalSuccess,
  clientsTotalFailure,
} from './clientsTotal/reducer';

export {
  addCompanyToImport,
  addCompaniesListToImport,
  clearCompaniesListImport,
  removeCompanyFromImport,
  requestGetCompaniesSnapshots,
  requestGetCompaniesSnapshotsSuccess,
  requestGetCompaniesSnapshotsFailure,
  requestPostEntitiesBatch,
  requestPostEntitiesBatchSuccess,
  requestPostEntitiesBatchFailure,
  requestPostConnectedCompanies,
  requestUpdateCompanyMap,
  requestPostCompanyMap,
  requestUpdateCompanyMapSuccess,
  requestUpdateCompanyMapFailure,
  requestFetchEntitiesBatch,
  requestFetchEntitiesBatchSuccess,
  requestFetchEntitiesBatchFailure,
} from './entitiesBatch/reducer';

export {
  requestConversationsData,
  openConversationsPanel,
  closeConversationsPanel,
  setConversationsFilters,
} from './conversations/reducer';

export {
  requestClientTagsData,
  requestAddClientTag,
  requestDeleteClientTag,
  requestEditClientTag,
} from './tags/reducer';

export {
  requestClientTimelineSuccess,
  requestClientTimeline,
  requestClientTimelineFailure,
} from './timeline/reducer';

export default combineReducers({
  client: clientReducer,
  overview: overviewReducer,
  wizzard: wizzardReducer,
  monitorOverallStats: monitorOverallStatsReducer,
  shareableReport: monitorShareableReportReducer,
  clientsRequiringAttention: clientsRequiringAttentionReducer,
  clientsTotal: clientsTotalReducer,
  entitiesBatch: entitiesBatchReducer,
  benchmark: benchmarkReducer,
  productMatches: productMatchesReducer,
  conversations: conversationsReducer,
  tags: tagsReducer,
  timeline: timelineReducer,
});
